module.exports = __webpack_public_path__ + "resources/icon_32_more.ee7faf61e4c0b092.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_32_more.png
// module id = 445
// module chunks = 0 1 2 3 4